import {isEmpty} from 'lodash'
import * as constant from "./contants"

export function getFPLValue(product, answers, fplData) {

    if (!isEmpty(fplData)) {
        let residencyAnswer, householdsizeAnswer
        residencyAnswer = answers.filter(function (item) {
            return item.name === constant.RESIDENCY
        })[0]
        householdsizeAnswer = answers.filter(function (item) {
            return item.name === constant.HOUSEHOLDSIZE
        })[0]
        if (!isEmpty(residencyAnswer) && !isEmpty(householdsizeAnswer)) {
            let residency, householdsize, fpl
            if (residencyAnswer.options.qualification.checkedContinental) {
                residency = 'all'
            } else if (residencyAnswer.options.qualification.checkedAlaska) {
                residency = 'Alaska'
            } else if (residencyAnswer.options.qualification.checkedHawaii) {
                residency = 'Hawaii'
            }
            householdsize = parseInt(householdsizeAnswer.options.checkedValue)
            fplData.forEach(function (item) {
                if (item.person === householdsize) {
                    fpl = item[residency]
                }
            })
            return formatCurrency(fpl, "$")
        }
    }
}

function formatCurrency(n, currency) {
    return currency + n.toFixed().replace(/./g, function (c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c
    })
}
